import React from "react"
import { connect } from "react-redux"
import { push as pushAction } from "connected-react-router"
import {get, keys} from 'lodash'
import Ionicon from "react-ionicons"
import {publicTagNames} from "../../../../data"
import "./CoolCard.less"
import { ValidationRequestInstance } from "../../../../node_modules/twilio/lib/rest/api/v2010/account/validationRequest";

function travelTime(productId) {
  const h = {
    nqlco9: 5,
    m5vyg6: 1
  }[productId]
  
  return h ? `线路需要${h}小时` : null
}
  
function cutName(s) {
  if (s.indexOf("(") > 0) {
    return s.split("(")[0]
  }
  else if (s.indexOf("（") > 0) {
    return s.split("（")[0]
  }
  else {
    return s
  }
}

const typesColor = {
  "2sn6dbecc3": "#D02800",
  "80ulgbfn21": "#00963D",
  k0bb01mkds: "#FF8802",
  chzlh8hklq: "#0979AA",
}
  
const getBorderRadius = (i, array) => {
  if (i == 0 && array.length == 1) return {borderRadius: "5px 0 10px 0"}
  else if (i == 0 && array.length > 1) return {borderRadius: "5px 0 0 0"}
  else if (i == array.length - 1) return {borderRadius: "0 0 10px 0"}
  else return {borderRadius: "0"}
}

const CoolCard = ({ product, push, url = "" }) => {
  
  const notHasSpanish = new RegExp(`^[^A-z]+$`, "g").test(product.chName)

  return (
    <div 
      className="card"
      onClick={() => push(url || `/catalogo/product/${product._id}`)}
    >
      <img src={product.foreground.image} />
      <div className="text">
        <div>{cutName(product.chName)}</div>
        {notHasSpanish && (
          <div>
            {product.name}
          </div>
        )}
        <div>{product.subtitle}</div>
        <div>
          <div>
            {
              product.tags && (
                <div className={"typeContainer"}>
                  {
                    keys(product.tags)
                      .filter(tag => product.tags[tag] && publicTagNames[tag])
                      .map((tag, i, array) => (
                        <div key={tag} className={"type"} style={{...getBorderRadius(i, array)}}>
                          <div
                            style={{
                              backgroundColor: typesColor[tag] || "#D02800",
                              borderRadius: "50%",
                              margin: "0 5px 0 5px",
                              width: "3vh",
                              height: "3vh",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}>
                            <Ionicon
                              icon={publicTagNames[tag].icon}
                              fontSize="2.5vh"
                              color="white"
                            />
                          </div>
                          <span>{publicTagNames[tag].name}</span>
                        </div>
                      ))
                  }
                </div>
              )
            }
            {/*product.tags.k0bb01mkds && <span>{travelTime(product._id) || product._id}</span>*/}
          </div>
        
          <span>
            {product.ppp || (product.price && product.price.general) || 0}
            欧/人
          </span>
        
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (stateIgnored, ownProps) => ({})

const mapDispatchToProps = dispatch => ({
  push: (url) => dispatch(pushAction(url)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CoolCard)


// WEBPACK FOOTER //
// ./src/app/catalogo/components/CoolCard.jsx